/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './gynic-history.reducer';

export const GynicHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const gynicHistoryList = useAppSelector(state => state.gynicHistory.entities);
  const loading = useAppSelector(state => state.gynicHistory.loading);
  const totalItems = useAppSelector(state => state.gynicHistory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="gynic-history-heading" data-cy="GynicHistoryHeading">
        <Translate contentKey="tinyMedicRestApp.gynicHistory.home.title">Gynic Histories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.gynicHistory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/gynic-history/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.gynicHistory.home.createLabel">Create new Gynic History</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.gynicHistory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {gynicHistoryList && gynicHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('menarche')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.menarche">Menarche</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('menarche')} />
                </th>
                <th className="hand" onClick={sort('cycleStart')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.cycleStart">Cycle Start</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cycleStart')} />
                </th>
                <th className="hand" onClick={sort('cycleEnd')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.cycleEnd">Cycle End</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cycleEnd')} />
                </th>
                <th className="hand" onClick={sort('loss')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.loss">Loss</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('loss')} />
                </th>
                <th className="hand" onClick={sort('interMenstrualBleed')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.interMenstrualBleed">Inter Menstrual Bleed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('interMenstrualBleed')} />
                </th>
                <th className="hand" onClick={sort('pain')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.pain">Pain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pain')} />
                </th>
                <th className="hand" onClick={sort('vaginalDischarge')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.vaginalDischarge">Vaginal Discharge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vaginalDischarge')} />
                </th>
                <th className="hand" onClick={sort('papSmear')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.papSmear">Pap Smear</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('papSmear')} />
                </th>
                <th className="hand" onClick={sort('contraception')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.contraception">Contraception</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contraception')} />
                </th>
                <th className="hand" onClick={sort('contraceptionDetails')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.contraceptionDetails">Contraception Details</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contraceptionDetails')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.gynicHistory.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {gynicHistoryList.map((gynicHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/gynic-history/${gynicHistory.id}`} color="link" size="sm">
                      {gynicHistory.id}
                    </Button>
                  </td>
                  <td>{gynicHistory.menarche}</td>
                  <td>{gynicHistory.cycleStart}</td>
                  <td>{gynicHistory.cycleEnd}</td>
                  <td>{gynicHistory.loss}</td>
                  <td>{gynicHistory.interMenstrualBleed}</td>
                  <td>{gynicHistory.pain}</td>
                  <td>{gynicHistory.vaginalDischarge}</td>
                  <td>{gynicHistory.papSmear}</td>
                  <td>{gynicHistory.contraception ? 'true' : 'false'}</td>
                  <td>{gynicHistory.contraceptionDetails}</td>
                  <td>{gynicHistory.active ? 'true' : 'false'}</td>
                  <td>{gynicHistory.cursor}</td>
                  <td>{gynicHistory.lastupdated}</td>
                  <td>{gynicHistory.microSec}</td>
                  <td>{gynicHistory.timestampentry}</td>
                  <td>
                    {gynicHistory.patient ? <Link to={`/gluco-user/${gynicHistory.patient.id}`}>{gynicHistory.patient.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/gynic-history/${gynicHistory.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/gynic-history/${gynicHistory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/gynic-history/${gynicHistory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.home.notFound">No Gynic Histories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={gynicHistoryList && gynicHistoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default GynicHistory;
